import ErroPagerContent from "./ErroPagerContent";

export default ErroPagerContent;